<form (ngSubmit)="onSubmit()">
<mat-dialog-content>
  <ng-container *ngTemplateOutlet="template"></ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex-spacer"></div>
  <button mat-raised-button mat-dialog-close [mat-dialog-close]="false">ยกเลิก</button>
  <button mat-raised-button class="submit-button">บันทึก</button>
</mat-dialog-actions>
</form>